import { Dispatch } from 'react';
import { apiClient, apiErrorHandler, EVENT_URL } from 'src/app/common/network';
import { PaginateResultMore } from 'src/app/common/types';
import { SpecialDayItem, SpecialDayListParam } from 'src/app/modules/Event/types/special-day-type';

export const getSpecialDays = async (
  params: SpecialDayListParam,
  dispatch?: Dispatch<any>,
): Promise<PaginateResultMore<SpecialDayItem>> => {
  return apiClient
    .get(`${EVENT_URL}/events/special-day-events`, { params })
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const addSpecialDays = async (data?: any): Promise<SpecialDayItem> => {
  return apiClient
    .post(`${EVENT_URL}/events/special-day-events`, data)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, undefined);
    });
};

export const editSpecialDays = async (data?: any): Promise<SpecialDayItem> => {
  return apiClient
    .put(`${EVENT_URL}/events/special-day-events`, data)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, undefined);
    });
};

export const getSpecificDayDetail = async (id: string, dispatch?: Dispatch<any>): Promise<SpecialDayItem> => {
  return apiClient
    .get(`${EVENT_URL}/events/special-day-events/${id}`)
    .then((response) => response?.data?.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
